export const CHART = {
	BAR: 'bar',
	PIE: 'pie'
};
export const REPRESENTATION = {
	TEXTUAL: 'textual',
	GRAPHICAL: 'graphical'
};
